module.exports = __webpack_public_path__ + "img/review.80d207f2.jpg";